import React, { useState, useContext } from 'react';
import classnames from 'classnames';
import DiscoveryContext from '../../../../../contexts/discoveryContext/contextV2';
import {
  checkboxOption,
  checkBoxIcon,
  checkBoxIconActive,
} from '../styles.module.css';

const DistanceSelect = ({ update }) => {
  const {
    filters: {
      distance: { availableDistances, selectedDistances: preSelectedDistances },
    },
  } = useContext(DiscoveryContext);

  const [distances, setDistances] = useState(
    availableDistances.map((distance) => ({
      ...distance,
      selected: !!preSelectedDistances.find((n) => n.id === distance.id),
    })),
  );

  const onToggle = (id) => {
    const selectedDistances = distances.map((distance) => {
      const selected =
        distance.id === id ? !distance.selected : distance.selected;
      return { ...distance, selected };
    });

    setDistances(selectedDistances);
    update({
      sportDistances: selectedDistances
        .filter((n) => n.selected)
        .map((n) => n.id),
    });
  };

  return (
    <div>
      {distances &&
        distances.map(({ id, label, selected }) => {
          return (
            <div
              key={id}
              className={checkboxOption}
              onClick={() => onToggle(id)}
              onKeyPress={() => onToggle(id)}
            >
              <span
                className={classnames(checkBoxIcon, {
                  [checkBoxIconActive]: selected,
                })}
              ></span>
              <span>{label}</span>
            </div>
          );
        })}
    </div>
  );
};

export default DistanceSelect;
